import React, {useEffect,useRef } from "react";
import {carrierPaymentsAPI } from "../../config/endpoints";
import $ from "jquery";
import DataTables from "datatables.net";

import "datatables.net-dt/css/jquery.dataTables.min.css";

export default function CarrierPayments({startDate}) {
    const DataTable = DataTables(Window, $);
    const tableRef = useRef();

  useEffect(() => {
     new DataTable(tableRef.current, {
      retrieve: true,
      processing: true,
      serverSide: true,
      iDisplayLength: 100,
      order: [[ 0, 'desc' ]],
      columnDefs: [{
        "defaultContent": "-",
        "targets": "_all"
      }],
      ajax: {
        url: carrierPaymentsAPI,
        method:"POST",
        xhrFields: {
          withCredentials: true
       },
        data:function(e){
            e.date = $('#filter-date').val();
          
        
      },
      },
      "destroy" : true,

      columns: [
        { title: "Shipment ID",data:'shipment_id',name:'carriers_aging.shipment_id'},
        { title: "Customer Name", data:'customer_name',name:'shipment.customer_name' },
        { title: "Carrier Name", data:'carrier_name',name:'carriers_aging.carrier_name' },
        { title: "Amount",data:'payable_amount',name:'carriers_aging.payable_amount', searchable:false },
        { title: "Date",data:'payment_initiated',name:'carrier_payment.payment_initiated', searchable:false },
        { title: "Status",data:function(d){ return (d.payment_status==1)?"Paid":''} ,name:'carrier_payment.payment_status', searchable:false},
      ],
    }).ajax.reload();
  }, [startDate]);
  

  return (
    <>
      <table ref={tableRef}></table>
    </>
  )
}
